
export function formatTime(seconds: number) {
  const m = Math.floor(seconds / 60) + ""
  const s = Math.floor(seconds % 60) + "";
  return `${m.padStart(2, '0')}:${s.padStart(2, '0')}`
}